'use strict'

function getRules() {
    return {
        cName: [
            { required: true, message: '请选择工作人', trigger: ['blur', 'change'] },
        ],
        job_content: [
            { required: true, message: '请填写工作内容', trigger: ['blur', 'change'] },
        ],
        project_name:[
            {required: true, message: '请选择项目名称', trigger: 'change,blur'},
        ],
        start_time: [
            { required: true, message: '请选择开始时间', trigger: ['blur', 'change'] },
        ],
        end_time: [
            { required: true, message: '请选择结束时间', trigger: ['blur', 'change'] },
        ]
    }
}
export {
    getRules
}
